import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';

// import { SearchSubItemComponent } from '../search-sub-item/search-sub-item.component';
// import { StockComponent } from '../stock/stock.component';
import { StockTransferComponent } from '../stock-transfer/stock-transfer.component';
import { TranslateService } from '@ngx-translate/core';
import { element } from 'protractor';


@Component({
  selector: 'app-stock-list',
  templateUrl: './stock-list.component.html',
  styleUrls: ['./stock-list.component.css']
})
export class StockListComponent implements OnInit {

  public menu_item_id = '45';
  public edit_auth;

  private dp = [];
  report_result = {};
  // subItemList = [];
  displayedColumns = ['sub_item_no', 'main_item_name', 'item_subcat_name', 'unit_name', 'baseline_amount', 
    'available_count', 'transfer', 'damage', 'consume'];  
    // 'item_cat_name''source', 'stock_no', , 'view', 'edit', 'del', 'expiry_date', 

  displayedColumns2 = ['sub_item_no', 'main_item_name', 'item_subcat_name', 'unit_name', 'baseline_amount', 
    'available_count'];

  dataSource = new MatTableDataSource(this.dp);
  // subItemDialogRef: MatDialogRef<SearchSubItemComponent>;
  // addDialogRef: MatDialogRef<StockComponent>; 'branch_id': '0', 
  transferDialogRef: MatDialogRef<StockTransferComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'type': 'stock_list', 'item_cat_id': '', 'item_subcat_id': '', 'branch_id': '0', 
    'store_id': '0', 'sub_item_no': '', 'title': 'عرض المخزون' };

  View_Stock; Sub_Item; Branch; Store; 
  // Branch_Msg; Store_Msg; Sub_Item_Msg; Sub_item_Placeholder;  

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('View_Stock').subscribe((res: string) => {
      this.View_Stock = res;
    });
    this.model['title'] = this.View_Stock;

    translate.get('Sub_Item').subscribe((res: string) => {
      this.Sub_Item = res;
    });

    translate.get('Branch').subscribe((res: string) => {
      this.Branch = res;
    });

    translate.get('Store').subscribe((res: string) => {
      this.Store = res;
    });
  }

  ngOnInit() {
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
  }

  onChangeRepResult = function (report_result: object) {
    console.log(report_result);
    this.report_result = report_result;

    this.dp = this.report_result['list'];
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td width="50%"> ' + this.Branch + ': ' + 
      (this.applicationConstants.user_lang == 'ar' ? this.report_result['branch_name'] : this.report_result['branch_name_en']);
    html_data += '</td>';

    html_data += '<td width="50%"> ' + this.Store + ': ' + 
      (this.applicationConstants.user_lang == 'ar' ? this.report_result['store_name'] : this.report_result['store_name_en']);
    html_data += '</td></tr>';
    
    if (this.report_result['sub_item_name'] != '')
      html_data += '<tr><td colspan="2"> ' + this.Sub_Item + ': ' + this.report_result['sub_item_name'] + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('stock_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  doAction(row, type) {
    row.branch_id = this.report_result['branch_id'];
    row.branch_name = this.report_result['branch_name'];
    row.branch_name_en = this.report_result['branch_name_en'];

    row.store_id = this.report_result['store_id'];
    row.store_name = this.report_result['store_name'];
    row.store_name_en = this.report_result['store_name_en'];

    let dialog_data = [{ data: row, type: type }];
    this.transferDialogRef = this.dialog.open(StockTransferComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.transferDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          (document.getElementById('btn_search') as HTMLInputElement).click();
      });
  }

  // searchSubItem() {
  //   this.subItemDialogRef = this.dialog.open(SearchSubItemComponent, {
  //     hasBackdrop: false,
  //   });
  //   this.subItemDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       if (result != undefined) {
  //         this.subItemList = result;
  //       }
  //     });
  // }

  // newStock() {
  //   this.addDialogRef = this.dialog.open(StockComponent, {
  //     hasBackdrop: false,
  //   });
  //   this.addDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //     });
  // }

  // editStock(row) {
  //   let dialog_data = [{
  //     'table_name': 'stock', 'stock_id': row.stock_id,
  //     'stock_no': row.stock_no,
  //     'branch_id': row.branch_id,
  //     'store_id': row.store_id,
  //     'sub_item_id': row.sub_item_id,
  //     'quantity': row.quantity,
  //     'expiry_date': row.expiry_date,
  //     'comment': row.comment
  //   },
  //   {
  //     'sub_item_id': row.sub_item_id,
  //     'sub_item_no': row.sub_item_no,
  //     'main_item_name': row.main_item_name,
  //     'main_item_name_en': row.main_item_name_en,
  //     'item_cat_name': row.item_cat_name,
  //     'item_subcat_name': row.item_subcat_name,
  //     'quantity': row.quantity,
  //     'stock_no': row.stock_no,
  //     'expiry_date': row.expiry_date,
  //   }];
  //   this.addDialogRef = this.dialog.open(StockComponent, {
  //     hasBackdrop: false,
  //     data: dialog_data
  //   });
  //   this.addDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       this.search();
  //     });
  // }

  // delStock(row) {
  //   if (confirm("نتيجة الحذف قد تؤثر على بيانات أخرى، هل أنت متأكد من رغبتك بالاستمرار؟")) {
  //     let values = [{ 'table_name': this.model['table_name'], 'stock_id': row.stock_id }];
  //     let obj = { cmd: 'deleteRec', values: values };

  //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
  //       .subscribe(data => {
  //         this.applicationConstants.appComp.hideBusyCursor();
  //         if (data.status['type'] == 'success') {
  //           alert(" تمت العملية بنجاح ");
  //           this.search();
  //         }
  //         else {
  //           alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
  //         }
  //       });
  //   }
  // }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }


}
